import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";

export interface TinhThanhPho {
  capDonVi: string;
  id: string;
  ma: string;
  ten: string;
}

// Hàm gọi API chung
const fetchData = async (endpoint) => {
  const { data } = await axiosInstance.get(`api/Master${endpoint}`);
  return data?.data?.items || data?.data || [];
};

// Hook chính
const useGeoData = () => {
  // Lấy danh sách tỉnh/thành phố
  const useTinhThanhPhos = (options?: Partial<UseQueryOptions<any>>) =>
    useQuery<TinhThanhPho[]>({
      queryKey: ["tinhthanhphos"],
      queryFn: () => fetchData("/tinhthanhphos"),
      ...options,
    });

  // Lấy danh sách quận/huyện
  const useQuanHuyens = () =>
    useQuery({
      queryKey: ["quanhuyens"],
      queryFn: () => fetchData("/quanhuyens"),
    });

  // Lấy danh sách phường/xã
  const usePhuongXas = () =>
    useQuery({
      queryKey: ["phuongxas"],
      queryFn: () => fetchData("/phuongxas"),
    });

  // Lấy quận/huyện theo tỉnh/thành phố
  const useQuanHuyensByTinhThanhPho = (tinhThanhPhoId) =>
    useQuery({
      queryKey: ["quanhuyens", tinhThanhPhoId],
      queryFn: () => fetchData(`/by-tinhthanhpho/${tinhThanhPhoId}/quanhuyens`),
      enabled: !!tinhThanhPhoId, // Chỉ chạy khi có tinhThanhPhoId
    });

  // Lấy phường/xã theo quận/huyện
  const usePhuongXasByQuanHuyen = (quanHuyenId) =>
    useQuery({
      queryKey: ["phuongxas", quanHuyenId],
      queryFn: () => fetchData(`/by-quanhuyen/${quanHuyenId}/phuongxas`),
      enabled: !!quanHuyenId,
    });

  // Lấy phường/xã theo tỉnh/thành phố
  const usePhuongXasByTinhThanhPho = (tinhThanhPhoId) =>
    useQuery({
      queryKey: ["phuongxas", tinhThanhPhoId],
      queryFn: () => fetchData(`/by-tinhthanhpho/${tinhThanhPhoId}/phuongxas`),
      enabled: !!tinhThanhPhoId,
    });

  // Lấy thông tin tỉnh/thành phố theo ID
  const useTinhThanhPhoById = (tinhThanhPhoId) =>
    useQuery({
      queryKey: ["tinhthanhpho", tinhThanhPhoId],
      queryFn: () => fetchData(`/tinhthanhpho/${tinhThanhPhoId}`),
      enabled: !!tinhThanhPhoId,
    });

  // Lấy tỉnh/thành phố theo quận/huyện
  const useTinhThanhPhoByQuanHuyen = (quanHuyenId) =>
    useQuery({
      queryKey: ["tinhthanhpho", quanHuyenId],
      queryFn: () => fetchData(`/tinhthanhpho/by-quanhuyen/${quanHuyenId}`),
      enabled: !!quanHuyenId,
    });

  // Lấy tỉnh/thành phố theo phường/xã
  const useTinhThanhPhoByPhuongXa = (phuongXaId) =>
    useQuery({
      queryKey: ["tinhthanhpho", phuongXaId],
      queryFn: () => fetchData(`/tinhthanhpho/by-phuongxa/${phuongXaId}`),
      enabled: !!phuongXaId,
    });

  return {
    useTinhThanhPhos,
    useQuanHuyens,
    usePhuongXas,
    useQuanHuyensByTinhThanhPho,
    usePhuongXasByQuanHuyen,
    usePhuongXasByTinhThanhPho,
    useTinhThanhPhoById,
    useTinhThanhPhoByQuanHuyen,
    useTinhThanhPhoByPhuongXa,
  };
};

export default useGeoData;
